
import {
    UPDATE_SUCCESS
} from 'Actions/Organization';

import {
    GET_CURRENT_SUCCESS,
    LOGIN_SUCCESS,
} from 'Actions/User'

const INITIAL_STATE = {};

const Organization = (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case LOGIN_SUCCESS:
        case GET_CURRENT_SUCCESS:

            try {
                const { organization } = action.response.teams[0]
                return {
                    ...state,
                    [organization.id]: organization
                }
            } catch (err) {
                // console.error('No Organization in teams', err)
            }

        case UPDATE_SUCCESS:

            return {
                ...state,
                [action.orgId]: [action.response],
            };

        default:
            return state;

    }

};

export { Organization };
